import styled from "styled-components";
import { fontSize, margin } from "../../globalStyle";

export const Wrapper = styled.div `
  margin-top: ${margin.mheader};
`

export const AboutUs = styled.div `
  
`

export const Subtitle = styled.h3 `
  font-size: ${fontSize.bodyLarge};
  font-weight: 500;
`